<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <div class="btn-group btn-group-justified" role="group" aria-label="...">
          <div class="btn-group">
            <button
              type="button"
              class="btn btn-primary btn-file btn"
              :disabled="files.length === maxLength"
            >
              <i class="fa fa-folder-open"></i> {{ placeholder }}
              <input
                type="file"
                id="inputFile"
                :accept="accept.join(', ')"
                hidden
                @change="onSelect"
                :multiple="multiple"
                :disabled="files.length === maxLength"
              />
            </button>
          </div>
          <div class="btn-group">
            <button
              type="button"
              class="btn btn-success"
              :disabled="loading || disabled || !files.length"
              @click.prevent="upload"
            >
              <i :class="{ 'el-icon-loading': loading, 'fa fa-upload': !loading }"></i>
              {{ loading ? 'Carregando' : 'Upload' }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="files.length">
      <div class="col-sm-12">
        <ul class="list-group">
          <li class="list-group-item" v-for="(file, index) of files" :key="index">
            <button type="button" class="btn btn-danger btn-xs pull-right" @click="remove(index)">
              <i class="fa fa-trash-o"></i>
            </button>
            {{ file.name }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'uploader',
  props: {
    minLength: {
      type: Number,
      default: 1
    },
    maxLength: {
      type: Number,
      default: 2
    },
    multiple: {
      type: Boolean,
      default: false
    },
    accept: {
      required: true,
      type: Array
    },
    placeholder: {
      default: 'Selecione um arquivo...'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      files: []
    }
  },
  mounted() {
    this.$bus.$on('uploader:reset', () => {
      this.files = []
    })
  },
  destroyed() {
    this.files = []
  },
  methods: {
    onSelect() {
      let input = this.$el.querySelector('input[type="file"]')
      // console.log(Array.from(input.files))
      let haveAllFileType = Array.from(input.files).every(
        file =>
          this.accept.includes(file.type) ||
          this.accept.some(x => file.name.toLowerCase().endsWith(x.toLowerCase()))
      )
      if (!haveAllFileType) {
        this.$iziToast.warning({
          title: 'Erro',
          message: `Somente arquivos do tipo ${this.accept.join(', ')} são aceitos!`,
          timeout: 5000
        })
      } else if (input.files.length < this.minLength) {
        this.$iziToast.info({
          title: 'Atenção!',
          message: `Você deve selecionar no mínimo ${this.minLength} arquivos para fazer upload!`,
          timeout: 5000
        })
      } else if (input.files.length > this.maxLength) {
        this.$iziToast.info({
          title: 'Atenção!',
          message: `Você deve selecionar no máximo ${this.maxLength} arquivos para fazer upload!`,
          timeout: 5000
        })
      } else {
        this.files = Array.from(input.files)
        this.$emit('on-select', this.files)
      }
      input.value = ''
    },

    remove(index) {
      this.files = this.files.filter((f, idx) => idx !== index)
      this.$emit('on-select', this.files)
    },

    upload() {
      this.$emit('upload', this.files)
      this.$emit('on-upload', this.files)
    },

    reset() {
      this.files = []
    }
  }
}
</script>

<style lang="css"></style>
